"use client"

import { sanitizeHtml } from "@/lib/sanitize"

/**
 * Renders legal page body content from Framer XLIFF HTML blobs.
 * Content originates from our own XLIFF exports and is sanitized via DOMPurify.
 */
export function LegalContent({
  html,
  localePrefix,
}: {
  html: string
  localePrefix?: string
}) {
  return (
    <div
      className="legal-content mt-12"
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(html, localePrefix) }}
    />
  )
}
